import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";

import VoiceImageNoBackground from "@/components/VoiceImageNoBackground";
import millify from "millify";
// Helper to format large numbers (e.g., 15000 -> 15K)

const VoiceCard = ({ voice, isSelected, onClick }) => {
  // Initialize rotation state - runs only once on mount
  const [randomRotation] = useState(() => (Math.random() - 0.5) * 20); // Range: -4 to 4 degrees

  const displayName = voice.artistname;
  const ariaLabel = isSelected
    ? `Deselect ${displayName}`
    : `Select ${displayName}`;
  const title = isSelected ? `Click to remove ${displayName}` : undefined; // Only show remove title if selected

  const rgb = voice?.image?.colorPalette?.Vibrant.rgb;
  const defaultRGB = [255, 255, 255]; // default to white color

  const safeRGB = (rgb) => {
    if (!rgb || rgb.length !== 3) {
      return defaultRGB;
    }
    return rgb;
  };

  // Generate a random subtle rotation angle for each card instance
  // const randomRotation = (Math.random() - 0.5) * 20; // REMOVED: Moved to useState
  const shadowColor = `rgb(${safeRGB(rgb).join(", ")}, 0.3)`;

  const shadowSize = 5;
  const shadowSpread = 6;
  return (
    <div
      onClick={onClick}
      aria-label={ariaLabel}
      className="tw-relative  tw-flex tw-flex-col tw-overflow-visible tw-items-center tw-gap-1.5 tw-w-full tw-cursor-pointer tw-rounded-2xl hover:tw-bg-gray-100 tw-transition-colors "
      title={title}
    >
      {isSelected && (
        <div className="tw-absolute tw-top-2 tw-z-10 tw-right-2 tw-bg-purple-700 tw-text-white tw-rounded-full tw-p-1 tw-flex tw-items-center tw-justify-center tw-border-2 tw-border-solid tw-border-white">
          <FaCheck size={10} />
        </div>
      )}
      <VoiceImageNoBackground
        model={voice}
        size={75}
        className={``}
        style={{
          filter: `
                  drop-shadow(${shadowSize}px 0 ${shadowSpread}px ${shadowColor})
                  drop-shadow(-${shadowSize}px 0 ${shadowSpread}px ${shadowColor})
                  drop-shadow(0 ${shadowSize}px ${shadowSpread}px ${shadowColor})
                  drop-shadow(0 -${shadowSize}px ${shadowSpread}px ${shadowColor})
                `,
          transform: `rotate(${randomRotation}deg)`,
        }}
      />

      <div className="tw-flex tw-flex-col tw-items-center tw-text-center tw-w-full tw-truncate">
        <div className="tw-text-sm tw-font-bold tw-text-black tw-truncate tw-w-full tw-text-wrap tw-line-clamp-1">
          {displayName}
        </div>
        {voice.uses !== undefined && (
          <div className="tw-text-xs tw-text-gray-500">
            {millify(voice.uses)} uses
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(VoiceCard);
